import { writable } from "svelte/store";
export const minutesOnlineStore = writable({
    minutesOnlineThisMonth: 0,
    minutesOnlineLastMonth: 0
});
